<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="90%"
    @close="handleClose"
    class="cost-list-dialog"
  >
    <div class="cost-list-container">
      <el-button
        @click="createCostDialogOpen()"
        type="primary"
        size="medium"
        class="create-button mb-3"
      >
        Шинэ зардал үүсгэх
      </el-button>

      <el-table :data="data" style="width: 100%" border stripe>
        <el-table-column label="Огноо" prop="date" width="120">
          <template slot-scope="scope">
            {{ formatDate(scope.row.date) }}
          </template>
        </el-table-column>
        <el-table-column v-if="costType === 'transfer'" label="Шилжүүлэх салбар" prop="transfer_from_branch_id" width="180">
          <template slot-scope="scope">
            {{ getBranchName(scope.row.transfer_from_branch_id) }}
          </template>
        </el-table-column>
        <el-table-column v-if="costType === 'transfer'" label="Хүлээн авах салбар" prop="transfer_to_branch_id" width="180">
          <template slot-scope="scope">
            {{ getBranchName(scope.row.transfer_to_branch_id) }}
          </template>
        </el-table-column>
        <el-table-column v-if="costType !== 'transfer'" label="Салбар" prop="branch_id" width="150">
          <template slot-scope="scope">
            {{ getBranchName(scope.row.branch_id) }}
          </template>
        </el-table-column>
        <el-table-column label="Тайлбар" prop="description"></el-table-column>
        <el-table-column label="Дүн" prop="amount" align="right" width="120">
          <template slot-scope="scope">
            <span class="amount-text">{{ formatAmount(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Дансны дугаар" prop="account_number" width="150"></el-table-column>

        <!-- Actions Column -->
        <el-table-column label="Үйлдэл" width="200" align="center">
          <template v-slot="scope">
            <el-button-group>
              <el-button
                @click="createCostDialogOpen(scope.row)"
                size="small"
                class="action-button"
              >
                Засварлах
              </el-button>
              <el-button
                @click="deleteRow(scope.row)"
                type="danger"
                size="small"
                class="action-button"
              >
                Устгах
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination -->
      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="data.length"
        layout="total, prev, pager, next"
        class="mt-3"
      />
    </div>
    <CreateCostDialog
      :visible="createDialogVisible"
      :selectedCost="targetCost"
      :costType="costType"
      @close="closeCreateDialog"
      @refresh="loadData"
    />
  </el-dialog>
</template>

<script>
import services from '@/helpers/services'
import { ElMessage, ElMessageBox } from 'element-ui'
import { mapGetters } from 'vuex'
import CreateCostDialog from './CreateCostDialog.vue'

export default {
  name: 'CostListDialog',
  components: {
    CreateCostDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    costType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      dialogVisible: this.visible,
      currentPage: 1,
      pageSize: 10,
      data: [],
      targetCost: {},
      branches: [],
      createDialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    dialogTitle () {
      if (this.costType === 'porter') {
        return 'Зардал - портер'
      } else if (this.costType === 'flow') {
        return 'Урсгал зардал'
      } else if (this.costType === 'transfer') {
        return 'Салбар хооронд шилжүүлэлт'
      }
      return 'Зардал'
    },
    isTransferType () {
      return this.costType === 'transfer'
    }
  },
  watch: {
    visible (newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.loadData()
        this.loadBranches()
      }
    },
    dialogVisible (newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  created () {
    this.loadBranches()
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.$emit('close')
    },
    async loadData () {
      try {
        let params = {}
        // Cost type-аас type_id олох
        if (this.costType === 'porter') {
          // Зардал - портер type_id-г олох хэрэгтэй
          const costTypesResponse = await services.getCostTypes()
          const costTypes = (costTypesResponse && costTypesResponse.data) ? costTypesResponse.data : (Array.isArray(costTypesResponse) ? costTypesResponse : [])
          const porterType = costTypes.find(ct => ct && ct.name && ct.name.toLowerCase().includes('портер'))
          if (porterType) {
            params = { type_id: porterType.id }
          }
        } else if (this.costType === 'flow') {
          // Урсгал зардал type_id-г олох хэрэгтэй
          const costTypesResponse = await services.getCostTypes()
          const costTypes = (costTypesResponse && costTypesResponse.data) ? costTypesResponse.data : (Array.isArray(costTypesResponse) ? costTypesResponse : [])
          const flowType = costTypes.find(ct => ct && ct.name && (ct.name.toLowerCase().includes('урсгал') || ct.name.toLowerCase().includes('урсгал зардал')))
          if (flowType) {
            params = { type_id: flowType.id }
          }
        } else if (this.costType === 'transfer') {
          // Салбар хооронд шилжүүлэлт type_id-г олох
          const costTypesResponse = await services.getCostTypes()
          const costTypes = (costTypesResponse && costTypesResponse.data) ? costTypesResponse.data : (Array.isArray(costTypesResponse) ? costTypesResponse : [])
          const transferType = costTypes.find(ct => ct && ct.name && (ct.name.toLowerCase().includes('шилжүүлэлт') || ct.name.toLowerCase().includes('шилжүүлэх')))
          if (transferType) {
            params = { type_id: transferType.id }
          }
        }
        const response = await services.getCosts(params)
        if (response) {
          let allData = response.data || []
          // Provider төсөлд зөвхөн нэвтэрсэн хэрэглэгчийн branch_id-тай адилхан зардлуудыг харуулах
          const userBranchId = (this.user && this.user.branch_id) ? this.user.branch_id : null
          // Салбар хооронд шилжүүлэлт type-тай зардлуудыг бүгдийг нь харуулах
          if (userBranchId && this.costType !== 'transfer') {
            // Зардал - портер, Урсгал зардал: branch_id === user.branch_id
            allData = allData.filter(cost => cost.branch_id === userBranchId)
          }
          this.data = allData
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message || error}`)
      }
    },
    handlePageChange (page) {
      this.currentPage = page
    },
    createCostDialogOpen (data) {
      this.targetCost = data || {}
      this.createDialogVisible = true
    },
    closeCreateDialog () {
      this.createDialogVisible = false
      this.targetCost = {}
    },
    async deleteRow (row) {
      try {
        await ElMessageBox.confirm('Та энэ зардлыг устгахдаа итгэлтэй байна уу?', 'Баталгаажуулалт', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        })
        await services.deleteCost(row.id)
        this.loadData()
        ElMessage.success('Амжилттай устгагдлаа!')
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('Устгахад алдаа гарлаа!')
        }
      }
    },
    formatAmount (amount) {
      if (!amount) return '0₮'
      return new Intl.NumberFormat('mn-MN', {
        style: 'currency',
        currency: 'MNT',
        minimumFractionDigits: 0
      }).format(amount)
    },
    formatDate (date) {
      if (!date) return '-'
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    async loadBranches () {
      try {
        const response = await services.getBranchesWeb()
        if (response && response.type === 'success') {
          this.branches = response.data || []
        } else if (response && response.data) {
          this.branches = response.data || []
        }
      } catch (error) {
        console.error('Error loading branches:', error)
        this.branches = []
      }
    },
    getBranchName (branchId) {
      if (!branchId) return '-'
      const branch = this.branches.find(b => b.id === branchId)
      return branch ? branch.branch_name : branchId
    }
  }
}
</script>

<style scoped>
.cost-list-container {
  padding: 0;
}

.create-button {
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 600;
}

.action-button {
  border-radius: 6px;
  margin: 0 2px;
}

.amount-text {
  font-weight: 600;
  color: #059669;
}

.mb-3 {
  margin-bottom: 12px;
}

.mt-3 {
  margin-top: 12px;
}
</style>
